<template>
  <v-dialog v-model="dialog" :fullscreen="$vuetify.breakpoint.xsOnly">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        :block="$vuetify.breakpoint.xsOnly"
        :large="$vuetify.breakpoint.smAndDown"
        class="my-1"
      >
        <v-icon small left>fa-edit</v-icon>Éditer un gabarit existant
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-row align="center" justify="space-between" no-gutters>
          <span :class="{ 'subtitle-1': $vuetify.breakpoint.xsOnly }"
            >Éditions des gabarit de commandes</span
          >
          <v-btn icon text @click="dialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text v-if="templates && !loading">
        <v-row>
          <v-col>
            <v-select
              v-model="selectedId"
              :items="templates"
              item-text="name"
              item-value="id"
              label="Gabarit à éditer"
            ></v-select>
          </v-col>
        </v-row>
        <section v-if="selected && selected !== null">
          <v-row no-gutters align="center">
            <v-text-field
              v-model="selected.name"
              label="Nom du gabarit"
            ></v-text-field>
          </v-row>
          <v-row align="center" justify="space-between">
            <v-btn
              color="error"
              @click="deleteTemplate"
              :block="$vuetify.breakpoint.xsOnly"
              :large="$vuetify.breakpoint.smAndDown"
              class="my-1"
            >
              <v-icon small left>fa-trash</v-icon>Supprimer le gabarit
            </v-btn>
            <v-btn
              color="success"
              @click="updateTemplate"
              :block="$vuetify.breakpoint.xsOnly"
              :large="$vuetify.breakpoint.smAndDown"
              class="my-1"
            >
              <v-icon small left>fa-save</v-icon>Enregistrer les modifications
            </v-btn>
          </v-row>
        </section>
      </v-card-text>
      <v-card-text v-else>
        <v-row class="my-3" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "OrderTemplateEditor",
  data() {
    return {
      templates: [],
      selectedId: undefined,
      selected: undefined,
      dialog: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters(["getOrganisationId"])
  },
  methods: {
    async getTemplates() {
      try {
        this.loading = true;
        this.templates = await api
          .getOrderTemplates()
          .filter(x => x.organisation === this.getOrganisationId);
      } finally {
        this.loading = false;
      }
    },
    async deleteTemplate() {
      const confirm = await this.$dialog.warning({
        title: "Supprimer",
        text: "Êtes-vous certain de vouloir supprimer ce gabarit?",
        actions: {
          false: "Non",
          true: "Oui"
        }
      });
      if (confirm === true) {
        try {
          this.loading = true;
          await api.deleteOrderTemplate(this.selectedId);
          this.dialog = false;
          this.selected = undefined;
          this.selectedId = undefined;
          this.$emit("update");
        } finally {
          this.loading = false;
        }
      }
    },
    async updateTemplate() {
      try {
        this.loading = true;
        await api.putOrderTemplate(this.selectedId, this.selected);
        this.dialog = false;
        this.selected = undefined;
        this.selectedId = undefined;
        this.$emit("update");
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === true) {
        this.getTemplates();
      }
    },
    selectedId(v) {
      this.selected = this.templates.find(x => x.id === v);
    }
  }
};
</script>

<style></style>
